import React from 'react';
import { useConnect } from '@lore/query-connect';
import { tags_educator } from '../../../../utils/query-helpers';

export default function useEducators(network, schoolStart, schoolEnd, extra = {}, eager = {}, $aggregations, $having) {
  return useConnect('user.find', {
    where: {
      eager: {
        $aggregations: $aggregations,
        $where: {
          ...tags_educator(),
          networkId: network?.id,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          $and: extra
        },
        $eager: eager,
        $having: $having
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
